import React from 'react';

const Button = ({ onClick, label = 'Save', className = '', secondary = false }) => {
    const buttonColours = secondary
        ? 'text-white bg-gray-400 hover:bg-gray-300 focus:outline-none focus:border-gray-300 focus:shadow-outline-gray active:bg-gray-300'
        : 'text-white bg-blue-600 hover:bg-blue-500 focus:outline-none focus:border-blue-700 focus:shadow-outline-indigo active:bg-blue-700';

    return (
        <button type="button" onClick={onClick} className={`w-full inline-flex justify-center py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md ${buttonColours} transition duration-150 ease-in-out ${className}`}>
            {label}
        </button>
    );
};

export default Button;
